module.exports = __webpack_public_path__ + "img/img_intro_1_1.16b9bc94.gif";